/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cms-card[_ngcontent-%COMP%]{box-shadow:0 5px 8px 0 rgba(0,0,0,.4);padding:0;margin-top:10px;border:1px solid #eee;border-radius:10px}.cms-duration[_ngcontent-%COMP%]{font-size:10px;border-style:solid;border-width:1px;padding:1px 3px;margin-left:2px}\n/*# sourceMappingURL=course-cart.component.css.map*/"];
export { styles as styles };
